// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"ead1486a","787":"39e43e66","802":"7ff9315b"}[chunkId] + ".chunk.js";
};